import { render, staticRenderFns } from "./EEscolhaDisciplinaPlanoBimestral.vue?vue&type=template&id=5b0d6355"
import script from "./EEscolhaDisciplinaPlanoBimestral.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplinaPlanoBimestral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports